import React from "react";
import {TableDateSearchProvider} from "../../../admin/Context/TableDateSearchContext.jsx";
import {SystemBriefs} from "./index.js";
import {ResponsiveView} from "../../../components/index.jsx";
import {Devices} from "../../../components/ResponsiveView/consts.js";

export const SystemBriefsWrapper = () => {
    return (
        <TableDateSearchProvider localStorageKey="systemBriefsSearchDate">
            <ResponsiveView devices={[Devices.desktop, Devices.mobile]}>
                <SystemBriefs />
            </ResponsiveView>
        </TableDateSearchProvider>
    );
};
